import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
	NMessageProvider,
	NDialogProvider,
	NConfigProvider,
	// createLocale,
} from 'naive-ui';
import hljs from 'highlight.js/lib/core';
import xml from 'highlight.js/lib/languages/xml';
import App from './App.vue';
import cs from './locale/cs';
import dateCs from './locale/dateCs';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

hljs.registerLanguage('xml', xml);

// const cs = createLocale(csLocale);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    locale: _unref(cs),
    "date-locale": _unref(dateCs),
    hljs: _unref(hljs)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NDialogProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NMessageProvider), {
            placement: "top",
            "keep-alive-on-hover": "",
            closable: "",
            duration: 5000
          }, {
            default: _withCtx(() => [
              _createVNode(App)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale", "date-locale", "hljs"]))
}
}

})